/**
 * BetaContext - Etat du mode Beta pour toute l'application
 *
 * Source unique de verite : la configuration est lue une seule fois via
 * getBetaConfig() et partagee, plutot que chaque composant refasse l'appel.
 * Cela evite des etats de chargement desynchronises entre le header, le menu
 * et les routes (les tarifs apparaitraient puis disparaitraient).
 *
 * Pendant le chargement, betaEnabled vaut false mais betaLoading vaut true :
 * un composant qui masque du contenu marketing doit masquer tant que
 * betaLoading est vrai, pour ne pas provoquer d'eclair de contenu.
 */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getBetaConfig } from '../services/settingsService';
import { useLanguage } from './LanguageContext';

const BetaContext = createContext({
    betaEnabled: false,
    betaLoading: true,
    betaConfig: null
});

export const BetaProvider = ({ children }) => {
    const { language } = useLanguage();
    const [state, setState] = useState({
        betaEnabled: false,
        betaLoading: true,
        betaConfig: null
    });

    useEffect(() => {
        let cancelled = false;
        setState(prev => ({ ...prev, betaLoading: true }));

        getBetaConfig(language)
            .then((cfg) => {
                if (cancelled) return;
                setState({
                    betaEnabled: !!cfg?.enabled,
                    betaLoading: false,
                    betaConfig: cfg || null
                });
            })
            .catch(() => {
                // En cas d'echec reseau on repli sur beta inactive : le site
                // garde sa forme complete plutot que de se restreindre a tort.
                if (cancelled) return;
                setState({ betaEnabled: false, betaLoading: false, betaConfig: null });
            });

        return () => { cancelled = true; };
    }, [language]);

    return (
        <BetaContext.Provider value={state}>
            {children}
        </BetaContext.Provider>
    );
};

export const useBeta = () => useContext(BetaContext);

export default BetaContext;
